import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-move-confirmation',
  templateUrl: './move-confirmation.component.html',
  styleUrls: ['./move-confirmation.component.scss']
})
export class MoveConfirmationComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
